const lines = [[ [ 3.0588, 36.7538 ], [ -3.7038, 40.4168 ] ],
[ [ 3.0588, 36.7538 ], [ 2.3522, 48.8566 ] ],
[ [ 3.0588, 36.7538 ], [ 28.9784, 41.0082 ] ],
[ [ 3.0588, 36.7538 ], [ 31.2357, 30.0444 ] ],
[ [ -84.388, 33.749 ], [ -87.6298, 41.8781 ] ],
[ [ -84.388, 33.749 ], [ -77.0369, 38.9072 ] ],
[ [ -84.388, 33.749 ], [ -80.1918, 25.7617 ] ],
[ [ 44.3661, 33.3152 ], [ 28.9784, 41.0082 ] ],
[ [ 44.3661, 33.3152 ], [ 51.389, 35.6892 ] ],
[ [ 44.3661, 33.3152 ], [ 67.0011, 24.8607 ] ],
[ [ 44.3661, 33.3152 ], [ 31.2357, 30.0444 ] ],
[ [ 100.5018, 13.7563 ], [ 80.2707, 13.0827 ] ],
[ [ 100.5018, 13.7563 ], [ 88.3639, 22.5726 ] ],
[ [ 100.5018, 13.7563 ], [ 106.6297, 10.8231 ] ],
[ [ 100.5018, 13.7563 ], [ 106.8283, -6.1805 ] ],
[ [ 116.4074, 39.9042 ], [ 126.978, 37.5665 ] ],
[ [ 116.4074, 39.9042 ], [ 121.4737, 31.2304 ] ],
[ [ -74.0721, 4.711 ], [ -99.1332, 19.4326 ] ],
[ [ -74.0721, 4.711 ], [ -80.1918, 25.7617 ] ],
[ [ -74.0721, 4.711 ], [ -77.0428, -12.0464 ] ],
[ [ -74.0721, 4.711 ], [ -58.3816, -34.6037 ] ],
[ [ -74.0721, 4.711 ], [ -46.6333, -23.5505 ] ],
[ [ -58.3816, -34.6037 ], [ -74.0721, 4.711 ] ],
[ [ -58.3816, -34.6037 ], [ -46.6333, -23.5505 ] ],
[ [ 31.2357, 30.0444 ], [ 3.0588, 36.7538 ] ],
[ [ 31.2357, 30.0444 ], [ 28.9784, 41.0082 ] ],
[ [ 31.2357, 30.0444 ], [ 44.3661, 33.3152 ] ],
[ [ 31.2357, 30.0444 ], [ 46.6753, 24.7136 ] ],
[ [ 31.2357, 30.0444 ], [ 32.5599, 15.5007 ] ],
[ [ 80.2707, 13.0827 ], [ 72.8777, 19.076 ] ],
[ [ 80.2707, 13.0827 ], [ 77.1025, 28.7041 ] ],
[ [ 80.2707, 13.0827 ], [ 88.3639, 22.5726 ] ],
[ [ 80.2707, 13.0827 ], [ 100.5018, 13.7563 ] ],
[ [ 80.2707, 13.0827 ], [ 106.8283, -6.1805 ] ],
[ [ -87.6298, 41.8781 ], [ -122.4194, 37.7749 ] ],
[ [ -87.6298, 41.8781 ], [ -73.5673, 45.5017 ] ],
[ [ -87.6298, 41.8781 ], [ -118.2437, 34.0522 ] ],
[ [ -87.6298, 41.8781 ], [ -99.1332, 19.4326 ] ],
[ [ -87.6298, 41.8781 ], [ -84.388, 33.749 ] ],
[ [ 77.1025, 28.7041 ], [ 51.389, 35.6892 ] ],
[ [ 77.1025, 28.7041 ], [ 44.3661, 33.3152 ] ],
[ [ 77.1025, 28.7041 ], [ 67.0011, 24.8607 ] ],
[ [ 77.1025, 28.7041 ], [ 88.3639, 22.5726 ] ],
[ [ 77.1025, 28.7041 ], [ 80.2707, 13.0827 ] ],
[ [ 7.0116, 51.4556 ], [ -0.1278, 51.5074 ] ],
[ [ 7.0116, 51.4556 ], [ 2.3522, 48.8566 ] ],
[ [ 7.0116, 51.4556 ], [ 9.19, 45.4642 ] ],
[ [ 7.0116, 51.4556 ], [ 30.3351, 59.9343 ] ],
[ [ 106.6297, 10.8231 ], [ 106.8283, -6.1805 ] ],
[ [ 106.6297, 10.8231 ], [ 100.5018, 13.7563 ] ],
[ [ 106.6297, 10.8231 ], [ 114.1095, 22.3964 ] ],
[ [ 106.6297, 10.8231 ], [ 120.9842, 14.5995 ] ],
[ [ 114.1095, 22.3964 ], [ 88.3639, 22.5726 ] ],
[ [ 114.1095, 22.3964 ], [ 121.4737, 31.2304 ] ],
[ [ 114.1095, 22.3964 ], [ 121.5654, 25.033 ] ],
[ [ 114.1095, 22.3964 ], [ 120.9842, 14.5995 ] ],
[ [ 114.1095, 22.3964 ], [ 106.6297, 10.8231 ] ],
[ [ 114.1095, 22.3964 ], [ 100.5018, 13.7563 ] ],
[ [ 28.9784, 41.0082 ], [ 30.3351, 59.9343 ] ],
[ [ 28.9784, 41.0082 ], [ 37.6173, 55.7558 ] ],
[ [ 28.9784, 41.0082 ], [ 44.3661, 33.3152 ] ],
[ [ 28.9784, 41.0082 ], [ 31.2357, 30.0444 ] ],
[ [ 28.9784, 41.0082 ], [ 3.0588, 36.7538 ] ],
[ [ 28.9784, 41.0082 ], [ 9.19, 45.4642 ] ],
[ [ 106.8283, -6.1805 ], [ 80.2707, 13.0827 ] ],
[ [ 106.8283, -6.1805 ], [ 100.5018, 13.7563 ] ],
[ [ 106.8283, -6.1805 ], [ 106.6297, 10.8231 ] ],
[ [ 106.8283, -6.1805 ], [ 151.2093, -33.8688 ] ],
[ [ 28.0473, -26.2041 ], [ 15.2663, -4.4419 ] ],
[ [ 28.0473, -26.2041 ], [ 32.5599, 15.5007 ] ],
[ [ 67.0011, 24.8607 ], [ 44.3661, 33.3152 ] ],
[ [ 67.0011, 24.8607 ], [ 51.389, 35.6892 ] ],
[ [ 67.0011, 24.8607 ], [ 77.1025, 28.7041 ] ],
[ [ 67.0011, 24.8607 ], [ 72.8777, 19.076 ] ],
[ [ 67.0011, 24.8607 ], [ 46.6753, 24.7136 ] ],
[ [ 32.5599, 15.5007 ], [ 28.0473, -26.2041 ] ],
[ [ 32.5599, 15.5007 ], [ 15.2663, -4.4419 ] ],
[ [ 32.5599, 15.5007 ], [ 3.3792, 6.5244 ] ],
[ [ 32.5599, 15.5007 ], [ 31.2357, 30.0444 ] ],
[ [ 15.2663, -4.4419 ], [ 3.3792, 6.5244 ] ],
[ [ 15.2663, -4.4419 ], [ 32.5599, 15.5007 ] ],
[ [ 15.2663, -4.4419 ], [ 28.0473, -26.2041 ] ],
[ [ 88.3639, 22.5726 ], [ 77.1025, 28.7041 ] ],
[ [ 88.3639, 22.5726 ], [ 80.2707, 13.0827 ] ],
[ [ 88.3639, 22.5726 ], [ 100.5018, 13.7563 ] ],
[ [ 88.3639, 22.5726 ], [ 114.1095, 22.3964 ] ],
[ [ 3.3792, 6.5244 ], [ -46.6333, -23.5505 ] ],
[ [ 3.3792, 6.5244 ], [ 15.2663, -4.4419 ] ],
[ [ 3.3792, 6.5244 ], [ 32.5599, 15.5007 ] ],
[ [ -77.0428, -12.0464 ], [ -99.1332, 19.4326 ] ],
[ [ -77.0428, -12.0464 ], [ -74.0721, 4.711 ] ],
[ [ -77.0428, -12.0464 ], [ -70.6693, -33.4489 ] ],
[ [ -0.1278, 51.5074 ], [ -74.006, 40.7128 ] ],
[ [ -0.1278, 51.5074 ], [ -3.7038, 40.4168 ] ],
[ [ -0.1278, 51.5074 ], [ 2.3522, 48.8566 ] ],
[ [ -0.1278, 51.5074 ], [ 7.0116, 51.4556 ] ],
[ [ -118.2437, 34.0522 ], [ -122.4194, 37.7749 ] ],
[ [ -118.2437, 34.0522 ], [ -87.6298, 41.8781 ] ],
[ [ -118.2437, 34.0522 ], [ -99.1332, 19.4326 ] ],
[ [ -118.2437, 34.0522 ], [ 151.2093, -33.8688 ] ],
[ [ -3.7038, 40.4168 ], [ -74.006, 40.7128 ] ],
[ [ -3.7038, 40.4168 ], [ -46.6333, -23.5505 ] ],
[ [ -3.7038, 40.4168 ], [ -0.1278, 51.5074 ] ],
[ [ -3.7038, 40.4168 ], [ 2.3522, 48.8566 ] ],
[ [ -3.7038, 40.4168 ], [ 3.0588, 36.7538 ] ],
[ [ 120.9842, 14.5995 ], [ 106.6297, 10.8231 ] ],
[ [ 120.9842, 14.5995 ], [ 114.1095, 22.3964 ] ],
[ [ 120.9842, 14.5995 ], [ 121.5654, 25.033 ] ],
[ [ 120.9842, 14.5995 ], [ 151.2093, -33.8688 ] ],
[ [ 120.9842, 14.5995 ], [ -122.4194, 37.7749 ] ],
[ [ -99.1332, 19.4326 ], [ -118.2437, 34.0522 ] ],
[ [ -99.1332, 19.4326 ], [ -87.6298, 41.8781 ] ],
[ [ -99.1332, 19.4326 ], [ -80.1918, 25.7617 ] ],
[ [ -99.1332, 19.4326 ], [ -74.0721, 4.711 ] ],
[ [ -99.1332, 19.4326 ], [ -77.0428, -12.0464 ] ],
[ [ -80.1918, 25.7617 ], [ -99.1332, 19.4326 ] ],
[ [ -80.1918, 25.7617 ], [ -84.388, 33.749 ] ],
[ [ -80.1918, 25.7617 ], [ -77.0369, 38.9072 ] ],
[ [ -80.1918, 25.7617 ], [ -74.0721, 4.711 ] ],
[ [ 9.19, 45.4642 ], [ 7.0116, 51.4556 ] ],
[ [ 9.19, 45.4642 ], [ 2.3522, 48.8566 ] ],
[ [ 9.19, 45.4642 ], [ 28.9784, 41.0082 ] ],
[ [ -73.5673, 45.5017 ], [ -87.6298, 41.8781 ] ],
[ [ -73.5673, 45.5017 ], [ -74.006, 40.7128 ] ],
[ [ -73.5673, 45.5017 ], [ -77.0369, 38.9072 ] ],
[ [ 37.6173, 55.7558 ], [ 30.3351, 59.9343 ] ],
[ [ 37.6173, 55.7558 ], [ 51.389, 35.6892 ] ],
[ [ 37.6173, 55.7558 ], [ 28.9784, 41.0082 ] ],
[ [ 72.8777, 19.076 ], [ 67.0011, 24.8607 ] ],
[ [ 72.8777, 19.076 ], [ 77.1025, 28.7041 ] ],
[ [ 72.8777, 19.076 ], [ 80.2707, 13.0827 ] ],
[ [ -74.006, 40.7128 ], [ -73.5673, 45.5017 ] ],
[ [ -74.006, 40.7128 ], [ -77.0369, 38.9072 ] ],
[ [ -74.006, 40.7128 ], [ -0.1278, 51.5074 ] ],
[ [ -74.006, 40.7128 ], [ -3.7038, 40.4168 ] ],
[ [ 135.5022, 34.6937 ], [ 121.5654, 25.033 ] ],
[ [ 135.5022, 34.6937 ], [ 139.6917, 35.6895 ] ],
[ [ 2.3522, 48.8566 ], [ -3.7038, 40.4168 ] ],
[ [ 2.3522, 48.8566 ], [ -0.1278, 51.5074 ] ],
[ [ 2.3522, 48.8566 ], [ 7.0116, 51.4556 ] ],
[ [ 2.3522, 48.8566 ], [ 9.19, 45.4642 ] ],
[ [ 2.3522, 48.8566 ], [ 3.0588, 36.7538 ]],
[ [ 46.6753, 24.7136 ], [ 31.2357, 30.0444 ] ],
[ [ 46.6753, 24.7136 ], [ 44.3661, 33.3152 ] ],
[ [ 46.6753, 24.7136 ], [ 67.0011, 24.8607 ] ],
[ [ -122.4194, 37.7749 ], [ 139.6917, 35.6895 ] ],
[ [ -122.4194, 37.7749 ], [ -118.2437, 34.0522 ] ],
[ [ -122.4194, 37.7749 ], [ -87.6298, 41.8781 ] ],
[ [ -122.4194, 37.7749 ], [ 120.9842, 14.5995 ] ],
[ [ -70.6693, -33.4489 ], [ -77.0428, -12.0464 ] ],
[ [ -46.6333, -23.5505 ], [ -58.3816, -34.6037 ] ],
[ [ -46.6333, -23.5505 ], [ -74.0721, 4.711 ] ],
[ [ -46.6333, -23.5505 ], [ -3.7038, 40.4168 ] ],
[ [ -46.6333, -23.5505 ], [ 3.3792, 6.5244 ] ],
[ [ 126.978, 37.5665 ], [ 116.4074, 39.9042 ] ],
[ [ 126.978, 37.5665 ], [ 139.6917, 35.6895 ] ],
[ [ 126.978, 37.5665 ], [ 121.4737, 31.2304 ] ],
[ [ 121.4737, 31.2304 ], [ 116.4074, 39.9042 ] ],
[ [ 121.4737, 31.2304 ], [ 126.978, 37.5665 ] ],
[ [ 121.4737, 31.2304 ], [ 139.6917, 35.6895 ] ],
[ [ 121.4737, 31.2304 ], [ 121.5654, 25.033 ] ],
[ [ 121.4737, 31.2304 ], [ 114.1095, 22.3964 ] ],
[ [ 30.3351, 59.9343 ], [ 7.0116, 51.4556 ] ],
[ [ 30.3351, 59.9343 ], [ 37.6173, 55.7558 ] ],
[ [ 30.3351, 59.9343 ], [ 28.9784, 41.0082 ] ],
[ [ 151.2093, -33.8688 ], [ -118.2437, 34.0522 ] ],
[ [ 151.2093, -33.8688 ], [ 106.8283, -6.1805 ] ],
[ [ 151.2093, -33.8688 ], [ 120.9842, 14.5995 ] ],
[ [ 121.5654, 25.033 ], [ 114.1095, 22.3964 ] ],
[ [ 121.5654, 25.033 ], [ 121.4737, 31.2304 ] ],
[ [ 121.5654, 25.033 ], [ 120.9842, 14.5995 ] ],
[ [ 121.5654, 25.033 ], [ 135.5022, 34.6937 ] ],
[ [ 51.389, 35.6892 ], [ 37.6173, 55.7558 ] ],
[ [ 51.389, 35.6892 ], [ 77.1025, 28.7041 ] ],
[ [ 51.389, 35.6892 ], [ 44.3661, 33.3152 ] ],
[ [ 51.389, 35.6892 ], [ 67.0011, 24.8607 ] ],
[ [ 139.6917, 35.6895 ], [ -122.4194, 37.7749 ] ],
[ [ 139.6917, 35.6895 ], [ 126.978, 37.5665 ] ],
[ [ 139.6917, 35.6895 ], [ 121.4737, 31.2304 ] ],
[ [ 139.6917, 35.6895 ], [ 135.5022, 34.6937 ] ],
[ [ -77.0369, 38.9072 ], [ -84.388, 33.749 ] ],
[ [ -77.0369, 38.9072 ], [ -80.1918, 25.7617 ] ],
[ [ -77.0369, 38.9072 ], [ -73.5673, 45.5017 ] ],
[ [ -77.0369, 38.9072 ], [ -74.006, 40.7128 ] ]
]

export default lines
